import { Helmet } from "react-helmet-async";

export default function MentionsLegalesPage() {
  return (
    <>
      <Helmet>
        <title>Mentions légales | FLOW</title>
        <meta name="description" content="Mentions légales du site flow-air.com — FLOW, SAS spécialisée en installation HVAC haut de gamme." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://flow-air.com/mentions-legales" />
      </Helmet>

      <section className="py-16 md:py-24 bg-white" data-testid="mentions-legales-page">
        <div className="container-flow max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-[#0E1A2B] mb-10 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
            Mentions légales
          </h1>

          <div className="space-y-10 text-[#475569] leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Éditeur du site</h2>
              <p>FLOW (FLOW)</p>
              <p>SAS au capital de 5 000€</p>
              <p>9 rue Quentin, 93300 Aubervilliers</p>
              <p>SIREN : 978 312 189</p>
              <p>N° TVA intracommunautaire : FR13 978 312 189</p>
              <p>Directeur de la publication : Cyril Dumont</p>
              <p>Email : <a href="mailto:contact@flow-air.com" className="text-[#00AFFF] hover:underline">contact@flow-air.com</a></p>
              <p>Tél : <a href="tel:+33650448840" className="text-[#00AFFF] hover:underline">06 50 44 88 40</a></p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Hébergement</h2>
              <p>IONOS SE</p>
              <p>7 Place de la Gare, 57200 Sarreguemines</p>
              <p><a href="https://www.ionos.fr" target="_blank" rel="noopener noreferrer" className="text-[#00AFFF] hover:underline">https://www.ionos.fr</a></p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Propriété intellectuelle</h2>
              <p>L'ensemble du contenu de ce site est la propriété exclusive de FLOW. Toute reproduction est interdite sans autorisation préalable.</p>
            </section>
          </div>
        </div>
      </section>
    </>
  );
}
